import { InsuredElectionCard, VehicleElectionCard } from '.';
import { INSURANCE_TYPES } from '../../views/configurationInsuranceTypes';
const { VEHICLE, INSURED } = INSURANCE_TYPES;

export default function ExposureElectionCard({ election, ...props }) {
  const insuranceType = election?.policy?.insuranceType?.type;
  if (insuranceType === INSURED) return <InsuredElectionCard election={election} {...props} />;
  if (insuranceType === VEHICLE) return <VehicleElectionCard election={election} {...props} />;
}
